import { LoadingOverlay, Center, Title, Text, Stack } from '@mantine/core';

interface LoadingDataProps {
  // string or node
  title?: React.ReactNode | null;
  titleOrder?: 1 | 2 | 3 | 4 | 5 | 6;
  blur?: number; // accepts 0–30, clamped internally
  note?: React.ReactNode;
  children?: React.ReactNode;
}

function LoadingData({ title = null, titleOrder = 1, blur = 2, note, children }: LoadingDataProps) {
  return (
    <div>
      {title && (
        <Center h="60vh">
          <Stack gap="xs" align="center">
            <Title order={titleOrder} style={{ whiteSpace: 'pre-wrap' }}>
              {title}
            </Title>
            {note && (
              <Text c="dimmed" ta="center">
                {note}
              </Text>
            )}
            {children}
          </Stack>
        </Center>
      )}
      {
        // Clamp blur to 0–30 to avoid extreme values
      }
      <LoadingOverlay visible overlayProps={{ blur: Math.max(0, Math.min(30, blur)) }} loaderProps={{ size: 'xl' }} />
    </div>
  );
}

export default LoadingData;
